<form *ngIf="groupFormGroup" [formGroup]="groupFormGroup">
    <p-card class="p-3" header="Datos generales">
        <div class="grid">
            <div class="col-6 input-field">
                <label for="name">Nombre *</label>
                <input pInputText formControlName="name" d-form-field-error />
            </div>
            <div class="col-4 input-field">
                <label for="responsibleUserId">Responsable *</label>
                <p-dropdown [options]="responsibles" formControlName="responsibleUserId" optionValue="id" [filter]="true" filterBy="name"
                    optionLabel="name" placeholder="Seleccione responsable" appendTo="body" d-form-field-error />
            </div>
        </div>

        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </p-card>

    <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="activeIndex">
        <p-tabPanel header="Usuarios" [disabled]="!group.id">
            <div class="flex justify-content-end pb-1">
                <p-button label="Añadir usuario" (click)="addUser()" styleClass="p-button-sm"
                    *ngIf="allowWrite"></p-button>
            </div>
            <p-table styleClass="mt-4" [value]="users" [paginator]="true" [rows]="25" [totalRecords]="totalUsersRecords"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="user.name">Usuario <p-sortIcon field="user.name"></p-sortIcon></th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-groupUser let-columns="columns">
                    <tr>
                        <td>{{groupUser.user.name}}</td>
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button *ngIf="allowDelete" (click)="deleteUser(groupUser)" [rounded]="true"
                                    styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="2">
                            No se han encontrado usuarios
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
    </p-tabView>
</form>
<p-confirmDialog></p-confirmDialog>